export default {
  collections: state => {
    return state.collections;
  },
  collectionById: state => id => {
    const filtered = state.collections.filter(item => {
      return parseInt(item.id, 10) === parseInt(id, 10);
    });

    return filtered.length === 1 ? filtered[0] : null;
  },
  collectionByRequestId: state => id => {
    let requests = [];
    if (id) {
      requests = state.requests.filter(item => {
        return parseInt(item.id, 10) === parseInt(id, 10);
      });
    }

    const lookupCollectionId = requests.length > 0 ? requests[0].collection_id : 1;
    const filtered = state.collections.filter(item => {
      return parseInt(item.id, 10) === parseInt(lookupCollectionId, 10);
    });

    return filtered.length === 1 ? filtered[0] : null;
  },
  requests: state => {
    return state.requests;
  },
  requestById: state => id => {
    const filtered = state.requests.filter(item => {
      return parseInt(item.id, 10) === parseInt(id, 10);
    });

    return filtered.length > 0 ? filtered[0] : null;
  },
  allowedMethods: state => {
    return state.allowedMethods;
  },
  requestState: state => {
    return state.requestState;
  },
  requestStartTime: state => {
    return state.requestStartTime;
  },
  requestEndTime: state => {
    return state.requestEndTime;
  },
  response: state => {
    return state.response;
  }
};